import axios from 'axios';
import { getLocalYYYYMMDD } from '../../../_mexablock/helpers';
const API_URL = process.env.REACT_APP_API;

const date = getLocalYYYYMMDD();

export async function getAllPaymentCommissions(filters?: {
  search?: string;
  start_date?: string;
  end_date?: string;
}) {
  const queryParams = new URLSearchParams();

  if (filters?.search) queryParams.append('search', filters.search);
  if (filters?.start_date) queryParams.append('start_date', filters.start_date);
  if (filters?.end_date) queryParams.append('end_date', filters.end_date);

  const response = await axios.get(
    `${API_URL}payments/commission-payment?${queryParams.toString()}`,
  );
  const data = response.data?.doc?.data;
  return data;
}

export async function downloadComprobantePagoPDF(id: number) {
  try {
    const response = await axios({
      url: `${API_URL}payments/commission-payment/${id}/pdf`,
      method: 'GET',
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `COMPROBANTE-PAGO-${id}-${date}.pdf`);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 0);
  } catch (error: any) {
    const parsed = await error.response.data.text();
    return JSON.parse(parsed);
  }
}
